<section class="targeted-roles-card" [class.targeted-roles-card--embedded]="embedded()">
  <div class="targeted-roles-card__header">
    <h2 class="targeted-roles-card__title">{{ title() }}</h2>
    @if (description(); as description) {
      <p class="targeted-roles-card__description">{{ description }}</p>
    }
  </div>

  <mat-checkbox class="targeted-roles-card__all" [checked]="all_selected()" (change)="onAllChange($event.checked)">
    {{ all_label() }}
  </mat-checkbox>

  <mat-divider class="targeted-roles-card__divider" />

  <ul class="targeted-roles-card__list" role="list">
    @for (option of options(); track option.id) {
      <li class="targeted-roles-card__item">
        <mat-checkbox [checked]="selected_ids_set().has(option.id)" (change)="onOptionChange(option.id, $event.checked)">
          {{ option.name }}
        </mat-checkbox>
      </li>
    }
  </ul>

  @if (error_message(); as message) {
    <p class="targeted-roles-card__error" role="alert">{{ message }}</p>
  }
</section>
